import React, { Component } from 'react';
import apiInstance from '../apiInstance';
import PopupModal from './popups/PopupModal';
import { connect } from 'react-redux';
import {changeCurrentUser} from '../../state/actionCreators/index'

class DeavadminUsers extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: '',
        };

    }

    render() {
        const users = this.state.users;

        return(
            <div className='mjwidev-main'>
                <h2>Welcome Dev Admin !!</h2>

            </div>
        )

    }



}

const mapStateToProps = (state) => {
    return (
        {
            user: state.currentUser,
        }
    )
}
const mapDispatchToProps = (dispatch) => {
    return (
      {
        changeCurrentUser: (user) => { dispatch(changeCurrentUser(user)) },
      }
    )
  }
export default connect(mapStateToProps, mapDispatchToProps)(DeavadminUsers);